<ng-container>
    {{alertMessage | localeVal:lang}}
</ng-container>

<ng-container *maiaPopUpFooter>
    <button *ngIf="type && type !== 'invalid-vehicle-owner'" maiaButton maiaButtonType="tertiary" (click)="control.cancel()">{{cancelButtonName | localeVal:lang}}</button>
    <button maiaButton [maiaButtonType]="buttonType" (click)="continue()">{{buttonText | localeVal:lang}}</button>
</ng-container>